export class ProductCategory
{
  id: string;
  index: number;
  name: string;
  category: string;
}
